export var PATHS;
(function (PATHS) {
    PATHS["HOME"] = "/";
    PATHS["RESULTS"] = "/results/:responseId";
    PATHS["LOGIN"] = "/login";
    PATHS["FORGOT_PASSWORD"] = "/forgot-password";
    PATHS["LOGIN_ERROR"] = "/login/login-error";
    PATHS["AUTH_ERROR"] = "/auth-error";
    PATHS["DASHBOARD"] = "/dashboard";
})(PATHS || (PATHS = {}));
